import { ControlResultColumnResponseDtoType } from "@/spz-api/model";

/**
 * Maps ControlResultColumnResponseDtoType to cell renderer type
 * Used to determine which cell component should render the value
 */
export function mapColumnTypeToCellType(
  columnType: string,
): "text" | "date" | "numeric" | "monetary" {
  const normalizedType = columnType.toUpperCase();

  switch (normalizedType) {
    case ControlResultColumnResponseDtoType.SHORT_DATE:
    case ControlResultColumnResponseDtoType.LONG_DATE:
    case ControlResultColumnResponseDtoType.HOUR_DATE:
    case ControlResultColumnResponseDtoType.MONTH_DATE:
      return "date";
    case ControlResultColumnResponseDtoType.INTEGER:
    case ControlResultColumnResponseDtoType.PERCENTAGE:
    case ControlResultColumnResponseDtoType.PERCENTAGE_WITH_TWO_DECIMALS:
    case ControlResultColumnResponseDtoType.PERCENTAGE_WITH_THREE_DECIMALS:
      return "numeric";
    case ControlResultColumnResponseDtoType.MONETARY:
      return "monetary";
    default:
      return "text";
  }
}
